<template>
  <div class="page-age">
    <div class="confirm" @click="clickConfirm"></div>
    <router-link to="/regulation" tag="div" class="cancel-btn"></router-link>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { verify, tools } from '@/utils'

export default {
  name: 'Welcome',
  data() {
    return {
      isMobile: '',
      isProtocolAccepted: false,
    }
  },
  computed: {
    ...mapState(['authorization']),
  },
  methods: {
    protocolToggle() {
      this.isProtocolAccepted = !this.isProtocolAccepted
    },
    clickConfirm() {
      this.$router.push({ path: '/fundingnew/index', query: this.$route.query })
    },
    clickCancel() {
      alert('未满18岁，请退出！')
    },
  },
  mounted() {
    if (!this._.isEmpty(this.authorization)) {
      const q = this.$route.query
      if(q.code){
        this.$router.replace({ path: '/logIn', query: this.$route.query })
      }else{
        this.$router.replace({ path: '/fundingnew/index', query: this.$route.query })
      }
      return
    }
    if (verify.isMobile()) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }

    if (verify.isWeixin()) {
      let shareInfo = {
        title: '绝对夜计划',
        desc: '绝对赛博夜计划，最高赢取5万元派对金，邀你一起造',
        imgUrl: this.$apiConfig.domain + '/static/funding_cpunk/share.png?v=1',
      }
      this.WXConfig.wxShowMenu(location.href, shareInfo)
    }
  },
}
</script>

<style lang="scss" scoped>
.page-age {
  min-height: 100%;
  background: #fff url('~@images/regular/welcome/bg.jpg') no-repeat center center;
  background-size: 100% auto;
  background-attachment: fixed;
}
.confirm {
  position: absolute;
  @include center();
  margin-left: 0;
  margin-top: pxtow(38);
  width: pxtow(400);
  height: pxtow(80);
}
.cancel-btn {
  position: absolute;
  @include center();
  margin-left: 0;
  margin-top: pxtow(140);
  width: pxtow(400);
  height: pxtow(80);
}
</style>



// WEBPACK FOOTER //
// src/pages/Welcome.vue